function initializeProductGridInfiniteScroll() {
  const container = document.getElementById('ProductGridContainer');
  if (!container) return;

  const grid = container.querySelector('#product-grid');
  const sentinel = container.querySelector('#ProductGridSentinel');
  const pagination = container.querySelector('.pagination-wrapper');

  if (window.__productGridInfiniteScrollObserver) {
    window.__productGridInfiniteScrollObserver.disconnect();
  }

  if (!grid || !sentinel || !pagination) return;

  pagination.style.display = 'none';

  let loading = false;

  const getNextUrl = () => {
    const nextLink = pagination.querySelector('.pagination__item--prev');
    return nextLink ? nextLink.href : null;
  };

  const loadNextPage = async () => {
    const nextUrl = getNextUrl();
    if (!nextUrl) {
      observer.disconnect();
      return;
    }

    loading = true;
    container.querySelector('.collection').classList.add('loading');

    try {
      const response = await fetch(nextUrl);
      const text = await response.text();
      const doc = new DOMParser().parseFromString(text, 'text/html');
      const newItems = doc.querySelectorAll('#product-grid > li');

      newItems.forEach((item) => grid.appendChild(item));

      const newPagination = doc.querySelector('.pagination-wrapper');
      pagination.innerHTML = newPagination ? newPagination.innerHTML : '';

      if (!newPagination) {
        observer.disconnect();
      }
    } catch (error) {
      observer.disconnect();
    } finally {
      loading = false;
      container.querySelector('.collection').classList.remove('loading');
    }
  };

  const observer = new IntersectionObserver(
    (entries) => {
      if (entries[0].isIntersecting && !loading) {
        loadNextPage();
      }
    },
    { rootMargin: '0px 0px 800px 0px' }
  );

  window.__productGridInfiniteScrollObserver = observer;
  observer.observe(sentinel);
}

document.addEventListener('DOMContentLoaded', initializeProductGridInfiniteScroll);
